import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

export const validEditActionGuard = () => {
  const router = inject(Router);
  const validActions = ['add', 'update', 'convert'];

  return (route: ActivatedRouteSnapshot) => {
    const action = route.paramMap.get('editAction');

    if (action && validActions.includes(action)) {
      return true;
    }
    router.navigate(['/not-found']);

    return false;
  };
};